import React from "react";
import { Box, Stack } from "@mui/material";
import { useGetOiwByOrgQuery } from "../../store/oiw/OiwApi";
import { GridColumns } from "../../utils/gridColumns";
import { GridActionsLayout } from "../Layouts";
import { FilterButton, ViewDetailsButton } from "../Buttons";
import { ArchiveStatusFilters } from "../Filters";
import { Status } from "../../utils/options";
import { DataGrid } from "@mui/x-data-grid";

const OiwArchivesCom = (props) => {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = React.useState("all");
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 4,
  });
  const [rowCountState, setRowCountState] = React.useState();

  const { data: oiwData, isFetching } = useGetOiwByOrgQuery({
    org_id: props.orgId,
    ...paginationModel,
    status: selectedStatus,
  });

  React.useEffect(() => {
    let temp = [];
    console.log(oiwData);
    if (oiwData?.oiw) {
      temp = oiwData?.oiw?.map((oiw, indx) => {
        return {
          id: oiw?.id,
          "S.No.": indx + 1,
          Status: oiw?.status,
          Date: new Date(oiw?.createdAt).toLocaleDateString("en-GB"),
          file: oiw?.file,
        };
      });
    }
    setRows(temp || []);
  }, [oiwData]);

  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      oiwData?.count ? oiwData?.count : prevRowCountState,
    );
  }, [oiwData?.count, setRowCountState]);

  const handleStatusChange = (e) => {
    console.log("Status", e.target.value);
    setSelectedStatus(e.target.value);
  };

  const columns = [
    ...new GridColumns()
      .serialNo()
      .date()
      .status()
      .actions({
        renderCell: (params) => {
          return (
            <GridActionsLayout>
              <ViewDetailsButton
                placeholder="View Document"
                handleClick={() => window.open(params.row.file, "_blank")}
                buttonStyles={{
                  backgroundColor: "#E4F4FF",
                  color: "#4B4B4B",
                  padding: "4px 8px",
                  borderRadius: "2rem",
                  "&:hover": {
                    backgroundColor: "#E4F4FF",
                  },
                }}
              />
            </GridActionsLayout>
          );
        },
      })
      .getCols(),
  ];
  return (
    <Box
      display={"flex"}
      flex={1}
      flexDirection={"column"}
      gap={4}
      className={props.styles}
    >
      <Stack direction={"row"} justifyContent={"right"}>
        <FilterButton
          buttonStyles={{ height: "32px" }}
          onClick={() => setOpen(!open)}
        />
      </Stack>
      <ArchiveStatusFilters
        open={open}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        status={[Status.APPROVAL, Status.APPROVED, Status.REJECTED]}
      />
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isFetching}
        disableRowSelectionOnClick
        pageSizeOptions={[5]}
        rowCount={rowCountState}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        sx={{
          "& .MuiDataGrid-toolbarContainer": {
            paddingY: 2,
            paddingX: 1,
          },
          "& .MuiDataGrid-row": {
            marginY: "0.82rem",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-root": {
            backgroundColor: "transparent",
            color: "#4B4B4B",
          },
        }}
      />
    </Box>
  );
};

export default OiwArchivesCom;
